import { useEffect, useState } from 'react';

// Retrieve the container dimension outside the iframe

export type OverlayContainerDimension = {
    width: number;
    height: number;
    success: boolean;
};

export function useOverlayContainerDimension(): OverlayContainerDimension {
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);
    // To determine if information is actually available
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        // Initially trigger a dimension update
        window.parent.postMessage({ type: 'psi-get-overlay-screen-dimension' }, '*');

        // Listen to dimension updates
        const callback = (event: any) => {
            if (event.data.type === 'psi-update-overlay-screen-dimension') {
                setWidth(event.data.width);
                setHeight(event.data.height);
                setSuccess(true);
            }
        };

        // Listen to dimension updates
        window.addEventListener('message', callback);
        // Cleanup
        return () => {
            window.removeEventListener('message', callback);
        };
    }, []);
    return { width, height, success };
}
